/* eslint-disable func-names */

/* global document */
/* eslint no-use-before-define: ["error", { "functions": false }] */
export default function(rootElement, trigger, close) {
  if (!trigger) {
    return;
  }

  let target = trigger.getAttribute('aria-controls');
  target = rootElement.querySelector(`#${target}`);

  // get current expanded state and set state of elements
  let expanded = (trigger.getAttribute('aria-expanded') === 'false');

  // get the correct aria label for either open or close menu
  // data-aria-label-open-true = 'close menu'
  // data-aria-label-open-false = 'open menu';
  const ariaLabel = trigger.getAttribute(`data-aria-label-open-${expanded}`);

  // set state to be expanded if the close param is set
  if (close) {
    expanded = false;
  }

  trigger.setAttribute('aria-expanded', expanded);
  trigger.setAttribute('aria-label', ariaLabel);
  target.setAttribute('aria-hidden', !expanded);

  // if lock body attribute is present, lock body scrolling
  if (trigger.getAttribute('data-lock-body')) {
    document.body.setAttribute('body-locked', expanded);
    document.body.setAttribute('data-lock-tabbing', expanded);
  }

  checkBounds(target);
}

function checkBounds(target) {
  const targetPosition = target.getBoundingClientRect();
  const bodyWidth = document.body.clientWidth;
  let offset = 0;

  if (targetPosition.right > bodyWidth) {
    offset = Math.floor(document.body.clientWidth - targetPosition.right);
  }

  target.style.marginLeft = `${offset}px`;
}
